module.exports = __webpack_public_path__ + "static/media/app04_ch01.1ae0c59f.png";